import styled from 'styled-components';

/*
 * The card the flag-on Xero config page is built from. Matches ExportDefaultsCard (T4-152) token for
 * token, so the page's cards stack consistently with the export defaults card below them (T4-205,
 * spec 038 D6). The design's own card is 8px with wider side padding; moving both to it is a
 * separate follow-up, so do not change one without the other.
 *
 * Shared with the QuickBooks config page (spec 048), so the two pages cannot drift apart.
 */
export const ConfigPageCard = styled.section`
	margin-top: ${props => props.theme.sys.spacing['600']};
	padding: ${props => props.theme.sys.spacing['600']};
	border: ${props => props.theme.sys.size.borderwidth.thin} solid ${props => props.theme.sys.color.border.decorative};
	border-radius: ${props => props.theme.sys.size.borderradius['2']};
`;

/* The organisations card (XeroOrganizationsSection, QuickbooksOrganizationsSection). */

export const Intro = styled.div`
	display: flex;
	gap: ${props => props.theme.sys.spacing['600']};
`;

export const IntroText = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${props => props.theme.sys.spacing['400']};
	min-width: 0;
`;

const divider = (props: {theme: {sys: {size: {borderwidth: {thin: string}}; color: {border: {decorative: string}}}}}) =>
	`${props.theme.sys.size.borderwidth.thin} solid ${props.theme.sys.color.border.decorative}`;

export const OrganizationsHeading = styled.div`
	margin-top: ${props => props.theme.sys.spacing['800']};
	padding-bottom: ${props => props.theme.sys.spacing['200']};
	border-bottom: ${divider};
`;

// Wraps so a long organisation name pushes its buttons onto the next line instead of off the card.
export const OrganizationRow = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
	gap: ${props => props.theme.sys.spacing['300']};
	padding: ${props => props.theme.sys.spacing['300']} 0;
	border-bottom: ${divider};
	overflow-wrap: anywhere;
`;

export const RowActions = styled.div`
	display: flex;
	gap: ${props => props.theme.sys.spacing['200']};
`;

export const Actions = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: ${props => props.theme.sys.spacing['200']};
	margin-top: ${props => props.theme.sys.spacing['450']};
`;
